<template>
  <div class="progressbar" :style="{'--stepcount': modstepcount, '--step': modstep}">
    <template v-for="(s, i) in modstepcount"  >
      <div :key="2*i" class="progressbar__step" :class="{'progressbar__step_passed':modstep>=i, 'progressbar__step_active':modstep==i}" >
        <StepPoint :active="modstep==i" :passed="modstep>i"/>
        <transition-group name="fade">
          <span v-if="modstep==i" :key="2 * i">{{getHeader(i)}}</span>
          <span v-if="modstep==i" :key="2 * i + 1" class="progressbar__num">{{ s == modstepcount? 100 : i * Math.floor(100 / (modstepcount - 1))}}%</span>
        </transition-group>
      </div>
      <div v-if="i != modstepcount - 1" :key="2*i + 1" class="progressbar__filler"></div>
    </template>    
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import StepPoint from './ui/StepPoint.vue'
export default {
  components: { StepPoint },
  data: ()=>({
    cobranges: [{from: 15, to: 21},{from: 23, to: 29}, {from:31, to: 37}]
  }),
  props: {
    step: {type: Number, required: true}
  },
  methods:{
    getHeader(s) {
      if (!this.cobscount || s < this.cobranges[0].from) return this.steptitles[s]
      let r1 = this.cobranges[0],
          r2 = this.cobranges[1],
          r3 = this.cobranges[2]

      const between = 1
      r2.f = r1.from + between + 1
      r3.f = r2.f + between + 1
      if (s == r1.from)
        return 'Анекта созаёмщика №1'
      if (this.cobscount == 1 || s <= r1.from + between) {
        let diff = s - r1.from
        return this.steptitles[r1.to + diff]
      }
      if (this.cobscount >= 2 && s == r2.f)
        return 'Анекта созаёмщика №2'
      if (this.cobscount == 2 || (this.cobscount == 3 && s < r3.f))
        return this.steptitles[r2.to + (s - r2.f)]
      if (this.cobscount == 3 && s == r3.f)
        return 'Анекта созаёмщика №3'
      return this.steptitles[r3.to + (s - r3.f)]
    }
  },
  computed:{
    ...mapGetters(['stepcount', 'steptitles', 'cobscount']),
    activeRanges(){
      if (this.cobscount == 0) return []
      if (this.cobscount == 1) return [this.cobranges[0]]
      if (this.cobscount == 2) return [this.cobranges[0],this.cobranges[1]]
      return this.cobranges
    },
    modstepcount(){
      return this.stepcount
    },
    modstep(){
      return this.step
    }
  }
}
</script>

<style lang="sass">
.progressbar
  width: 220px
  min-width: 220px
  display: flex
  flex-direction: column
  --stepheight: 26px
  --maxspace: 24px
  height: calc(100vh - 32px)
  margin-top: calc(50px * var(--step) * -1) !important
  margin-bottom: -70px
  max-height: calc((var(--stepheight) + var(--maxspace)) * var(--stepcount) - var(--maxspace))
  &__step
    position: relative
    display: flex
    height: 26px
    align-items: center
    font-size: 16px
    svg
      z-index: 1
      position: relative
      margin-right: 8px
    &::before, &::after
      content: ''
      width: 2px
      position: absolute
      left: 12px
      top: 0px
      height: 50%
      transition: background .4s ease-out
      background: colors.$dim
    &::after
      top: 50%
    &:first-child::before
      display: none
    &:last-child::after
      display: none
    &_passed:nth-child(n)
      &::before, &::after
        background: colors.$red
    &_passed:not(&_active) + .progressbar__filler
      background: colors.$red
  &__filler
    transition: background .4s ease-out
    flex-grow: 1
    max-height: var(--maxspace)
    width: 2px
    margin-left: 12px
    transition-group: .4s ease-out
    background: colors.$dim
  &__num
    position: absolute
    font-weight: 500
    font-size: 16px
    line-height: 26px    
    color: colors.$red
    left: -34px
    bottom: -19px
  &__step:last-child &__num
    left: -44px
    bottom: 25px

</style>